import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore } from 'redux-persist'
import store from 'hooks/store'
import { CssBaseline } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React from 'react'
import { disableConsoleInProduction } from 'util/logger'
// import './assets/css/style.css'

// 운영 환경에서 console 비활성화
disableConsoleInProduction()

// QueryClient 설정 최적화
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5분간 캐시 유지
			gcTime: 10 * 60 * 1000, // 10분간 가비지 컬렉션 방지
			retry: (failureCount, error: any) => {
				// 4xx 에러는 재시도하지 않음
				if (error?.response?.status >= 400 && error?.response?.status < 500) {
					return false
				}
				// 최대 3번 재시도
				return failureCount < 3
			},
			retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
		},
		mutations: {
			retry: 1,
		},
	},
})

let persistor = persistStore(store)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<QueryClientProvider client={queryClient}>
				<PersistGate
					loading={null}
					persistor={persistor}
				>
					<BrowserRouter>
						<CssBaseline />
						<App />
						<ReactQueryDevtools initialIsOpen={false} />
					</BrowserRouter>
				</PersistGate>
			</QueryClientProvider>
		</Provider>
	</React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
